export class InputValidator {
    static isLetterOrSpace(event: KeyboardEvent): boolean {
      // Verificamos si la tecla presionada es la tecla de pegar (Paste)
      if (event.ctrlKey && event.key.toUpperCase() === 'V') {
        return true;
      }
  
      // Obtenemos la tecla presionada
      const key = event.key;
  
      // Verificamos si la tecla presionada es una letra de la A a la Z, la letra Ñ o un espacio en blanco
      const allowedChars = /^[A-Za-zÑñ\s]+$/;
      if (allowedChars.test(key)) {
        return true;
      } else {
        event.preventDefault(); // Prevenimos la acción por defecto si no es un carácter permitido
        return false;
      }
    }
  
    static isLetter(event: KeyboardEvent): boolean {
      // Verificamos si la tecla presionada es la tecla de pegar (Paste)
      if (event.ctrlKey && event.key.toUpperCase() === 'V') {
        return true;
      }
  
      const key = event.key;
      // Verificamos si la tecla presionada es una letra de la A a la Z o la letra Ñ
      const allowedChars = /^[A-Za-zÑñ]+$/;
      if (allowedChars.test(key)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }
  
    static isNumber(event: KeyboardEvent): boolean {
      // Verificamos si la tecla presionada es la tecla de pegar (Paste)
      if (event.ctrlKey && event.key.toUpperCase() === 'V') {
        return true;
      }
  
      const key = event.key;
      // Verificamos si la tecla presionada es un número
      const allowedChars = /^[0-9]+$/;
      if (allowedChars.test(key)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }
  }
  